import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import { FollowupEditComponent } from '../followup-edit/followup-edit.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Location } from '@angular/common'

@Component({
  selector: 'app-followup-detail',
  templateUrl: './followup-detail.component.html',
  styleUrls: ['./followup-detail.component.scss']
})
export class FollowupDetailComponent implements OnInit {
  followup_id: any;
  followup_detail: any = {};
  loader: boolean = false;
  dr_type: any;


  constructor(public toast: ToastrManager, public dialog: MatDialog, public serve: DatabaseService, public route: ActivatedRoute,public location: Location) {

    this.route.params.subscribe(params => {
      console.log(params)
      this.followup_id = params.id;
      this.dr_type = params.dr_type;
      console.log(this.dr_type)
      this.serve.currentUserID = params.id
      this.get_followup_detail();
    });

  }

  ngOnInit() {
  }

  back(): void {
    this.location.back()
  }
  get_followup_detail() {
    this.loader = true;
    this.serve.post_rqst({ 'followup_id': this.followup_id,'dr_type':this.dr_type }, "Followup/followupDetail").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.followup_detail = result['followup_detail'][0];
        this.loader = false;

      } else {
        this.loader = false;
        this.toast.errorToastr(result['statusMsg']);
      }

    }, err => {
      this.loader = false;
      this.toast.errorToastr('Something went wrong');
    })
  }


  edit_followup_modal() {
    const dialogRef = this.dialog.open(FollowupEditComponent, {
      width: '750px',
      data: {
        'followup_detail': this.followup_detail,
        'from': 'followup detail page'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_followup_detail()
    });
  }



}
